var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 13.3333C9.41451 13.3333 10.7711 12.7714 11.7713 11.7712C12.7715 10.771 13.3334 9.41448 13.3334 7.99999C13.3334 6.5855 12.7715 5.22895 11.7713 4.22875C10.7711 3.22856 9.41451 2.66666 8.00002 2.66666C6.58553 2.66666 5.22898 3.22856 4.22878 4.22875C3.22859 5.22895 2.66669 6.5855 2.66669 7.99999C2.66669 9.41448 3.22859 10.771 4.22878 11.7712C5.22898 12.7714 6.58553 13.3333 8.00002 13.3333ZM10.3542 7.02082L7.68752 9.68749C7.49169 9.88332 7.17502 9.88332 6.98127 9.68749L5.64794 8.35416C5.4521 8.15832 5.4521 7.84166 5.64794 7.64791C5.84377 7.45416 6.16044 7.45207 6.35419 7.64791L7.33335 8.62707L9.64585 6.31249C9.84169 6.11666 10.1584 6.11666 10.3521 6.31249C10.5459 6.50832 10.5479 6.82499 10.3521 7.01874L10.3542 7.02082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitCheckCircle);
export default __webpack_public_path__ + "static/media/aitCheckCircle.222b5d236691591034a1f78813161242.svg";
export { ForwardRef as ReactComponent };